
/**
 * 📈 BRAINROT ANALYTICS ENGINE (Brave Bypass Edition)
 * Uses standard gtag if available, falls back to server-side proxy if blocked.
 */

export const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID || 'G-CFPVS3PH2Z';

// Simple session ID for the session duration
const SESSION_ID = Math.random().toString(36).substring(2, 15);

/**
 * Tracks a custom event.
 */
export const trackEvent = async (eventName: string, eventParams: Record<string, any> = {}) => {
  // 1. Try standard gtag first
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('event', eventName, {
      ...eventParams,
      session_id: SESSION_ID
    });
    console.log(`[Analytics] Event tracked (via gtag): ${eventName}`, eventParams);
    return;
  }

  // 2. Fallback to our OWN API (Proxy), which Brave won't block
  try {
    const response = await fetch('/api/analytics', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        event_name: eventName,
        event_params: {
          ...eventParams,
          app_name: 'Brainrot Blast',
          platform: 'web',
          aura_level: 'maximum'
        },
        session_id: SESSION_ID
      })
    });

    if (!response.ok) {
      console.warn(`[Analytics] Proxy failed for ${eventName}`);
    } else {
      console.log(`[Analytics] Event tracked (via Proxy): ${eventName}`, eventParams);
    }
  } catch (error) {
    console.error(`[Analytics] Error tracking ${eventName}:`, error);
  }
};

/**
 * Tracks a page view.
 */
export const trackPageView = (pagePath: string, pageTitle: string) => {
  // Standard gtag handles initial page view, but we track manual view changes
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('config', GA_MEASUREMENT_ID, {
      page_path: pagePath,
      page_title: pageTitle
    });
  }

  trackEvent('page_view', {
    page_path: pagePath,
    page_title: pageTitle
  });
};
